import { CloseIcon } from '@repo/ui'

export function CloseNotificationIcon() {
  return (
    <CloseIcon className="w-3 h-3 drop-shadow-[0_0_2px_rgba(0,0,0,0.25)] [&_path[opacity='0.4']]:opacity-100 transition-transform duration-300 group-hover:scale-110 group-hover:rotate-90" />
  )
}